<ng-template #fullscreenTpl>
    <app-full-screen-image></app-full-screen-image>
</ng-template>
<div class="viewer-container">
    <div [class.d-none]="!viewer.isMasterMap() && !isToolbarOpen"
         class="map-toolbar left-toolbar-container d-flex flex-column align-items-center">
        <app-properties-locations-manager
                class="d-flex"
                #infoPropertiesManager
                [disabled]="!(mapService.mapInitialized$ | async)"
                [infoProperties]="viewerService.infoProperties$ | async"
                [enabledProperties]="viewerService.enableProperties$ | async"
                [enabledPropertiesReport]="viewerService.enablePropertiesReport$ | async"
                [enabledTool]="toolbarService.enabledTool$ | async"></app-properties-locations-manager>

        <app-developer-tools class="d-flex" *ngIf="viewerService.developerTools$ | async"></app-developer-tools>
        <app-collection-manager class="d-flex" *ngIf="viewerService.developerTools$ | async"></app-collection-manager>
        <app-user-data #userData class="d-flex" [enabledProperties]="viewerService.enableProperties$ | async"
                       [enabledTool]="toolbarService.enabledTool$ | async"></app-user-data>
        <app-dock-gallery
                class="d-flex"
                #dockGallery
                [zoomEvent]="viewerService.zoomEnd$ | async"
                [display]="galleryService.displayGallery$ | async"
                [enabledTool]="toolbarService.enabledTool$ | async"
                [loadImages]="viewerService.loadedImages$ | async"
                [collections]="galleryService.collections$ | async"
                [images]="galleryService.allImages$ | async"
                [filteredImages]="galleryService.filteredImages$ | async"
                [enableDebugOptions]="viewerService.developerTools$ | async"
                [status]="galleryService.status$ | async"
                [selectedCollection]="galleryService.selectedCollection$ | async"
                [selectedFilter]="galleryService.selectedFilter$ | async"
                [selectImage]="viewerService.image$ | async"
                [discreteEnabled]="mapService.discreteEnabled$ | async"></app-dock-gallery>
        <app-measurement-toolbar class="d-flex"
                                 [discreteEnabled]="mapService.discreteEnabled$ | async"
                                 [measurementToolAllowed]="viewerService.enableMeasurements$ | async"
                                 [activeToolPanel]="measurementCommunicatorService.measurementToolStatus$ | async"></app-measurement-toolbar>
        <app-phoenix-brightness-contrast class="d-flex" [mode]="viewerService.collectionMode"
                                         [enabledTool]="toolbarService.enabledTool$ | async"></app-phoenix-brightness-contrast>
        <app-phoenix-dual-view class="d-flex"></app-phoenix-dual-view>
        <app-swipe-viewer class="d-flex"
                          *ngIf="!(viewerService.projectStatus$ | async)?._multiLayerEnabled"
                          [projectStatus]="viewerService.projectStatus$ | async"
                          [geotiffStatus]="mapService.geotiffStatus$ | async"
                          [zoomEvent]="viewerService.zoomEnd$ | async"
                          [searchEvent]="viewerService.searchEnd$ | async"
                          [dualView]="dualView"
                          [leftAOI]="sbsLeftLayer"
                          [rightAOI]="sbsRightLayer"
                          (visibleEvent)="enableSbsViewer = $event"
                          (sbsRightLayer)="sbsRightLayer = $event"
                          (sbsLeftLayer)="sbsLeftLayer = $event"
                          [status]="viewerService.enableSwipe$ | async"
                          [discreteEnabled]="mapService.discreteEnabled$ | async"></app-swipe-viewer>
        <app-multilayer-swipe-viewer
                class="d-flex"
                *ngIf="(viewerService.projectStatus$ | async)?._multiLayerEnabled"
                [projectStatus]="viewerService.projectStatus$ | async"
                [geotiffStatus]="mapService.geotiffStatus$ | async"
                [zoomEvent]="viewerService.zoomEnd$ | async"
                [searchEvent]="viewerService.searchEnd$ | async"
                [dualView]="dualView"
                [leftAOI]="sbsLeftLayer"
                [rightAOI]="sbsRightLayer"
                (visibleEvent)="enableSbsViewer = $event"
                (sbsRightLayer)="sbsRightLayer = $event"
                (sbsLeftLayer)="sbsLeftLayer = $event"
                [status]="viewerService.enableSwipe$ | async"
                [discreteEnabled]="mapService.discreteEnabled$ | async"></app-multilayer-swipe-viewer>
        <app-screenshot class="d-flex"></app-screenshot>
        <app-phoenix-download-imagery class="d-flex" [mode]="viewerService.collectionMode"
                                      [selectedImage]="viewerService.image$ | async"></app-phoenix-download-imagery>
        <app-export-geotiff class="d-flex"
                            #exportGeotiff
                            *ngIf="exportGeoTiffAllowed"
                            [enabledTool]="toolbarService.enabledTool$ | async"
                            [measurementStatus]="measurementCommunicatorService.measurementToolStatus$ | async"
                            [deactivateTool]="viewerService.deactivateTools$ | async"
                            [zoomEvent]="viewerService.zoomEnd$ | async"
                            [mode]="viewerService.collectionMode"
                            [centerAOI]="(viewerService.projectStatus$ | async)?.centerAOI"
                            [mapStatus]="mapService.mapStatus$ | async"
                            [swipeStatus]="mapService.swipeStatus$ | async"></app-export-geotiff>
    </div>
    <div #mapContainer class="map-container">
        <app-image-info *ngIf="showImageInfo()"></app-image-info>
        <div class="expand-dual-view-container">
            <button
                    *ngIf="dualView && !viewer.isMasterMap()"
                    matTooltipPosition="after"
                    matTooltip="{{ isToolbarOpen ? 'Collapse toolbar' : 'Expand toolbar' }}"
                    (click)="openToolbar(); viewer.updateSizeMap()"
                    class="left-toolbar-container-arrow">
                <mat-icon *ngIf="isToolbarOpen" class="arrow-icon">keyboard_arrow_left</mat-icon>
                <mat-icon *ngIf="!isToolbarOpen" class="arrow-icon">keyboard_arrow_right</mat-icon>
            </button>
        </div>

        <div class="top-toolbar-container" [ngClass]="{ 'dual-view-toolbar': dualView }"
             *ngIf="!(viewerService.projectStatus$ | async)?.multiLayerEnabled">
            <app-dummy-projects-timeline
                    *ngIf="viewerService.showDummyTimeline() && !(viewerService.isActivatedBaseMap$ | async)"
                    [enabledFilters]="mapService.mapInitialized$ | async"
                    [enabledDebug]="viewerService.developerTools$ | async"
                    [timelineBlocked]="viewerService.lockCollection$ | async"
                    [swipeStatus]="viewerService.enableSwipe$ | async"
            ></app-dummy-projects-timeline>

            <app-projects-timeline
                    *ngIf="!enableSbsViewer && this.viewerService.show2DTimeline() && !(viewerService.isActivatedBaseMap$ | async)"
                    [aois]="(viewerService.projectStatus$ | async)?.enabledAOIs"
                    [centerAOI]="(viewerService.projectStatus$ | async)?.centerAOI"
                    [enabledFilters]="mapService.mapInitialized$ | async"
                    [enabledDebug]="viewerService.developerTools$ | async"
                    [timelineBlocked]="viewerService.lockCollection$ | async"
                    [swipeStatus]="viewerService.enableSwipe$ | async"
                    [enableContrast]="viewerService.enableContrast$ | async"
            ></app-projects-timeline>

            <app-sbs-projects-timeline
                    [aois]="(this.viewerService.projectStatus$ | async)?.enabledAOIs"
                    (layerChange)="this.sbsLeftLayer = $event"
                    [aoi]="this.sbsLeftLayer"
                    *ngIf="!dualView && enableSbsViewer && this.viewerService.show2DTimeline() && !(viewerService.isActivatedBaseMap$ | async)"
                    [enabledFilters]="false"
                    [enabledDebug]="viewerService.developerTools$ | async"
                    [timelineBlocked]="viewerService.lockCollection$ | async"
                    [swipeStatus]="viewerService.enableSwipe$ | async"
            ></app-sbs-projects-timeline>

            <app-sbs-projects-timeline
                    [aois]="(this.viewerService.projectStatus$ | async)?.enabledAOIs"
                    (layerChange)="this.sbsRightLayer = $event"
                    [aoi]="this.sbsRightLayer"
                    *ngIf="!dualView && enableSbsViewer && this.viewerService.show2DTimeline() && !(viewerService.isActivatedBaseMap$ | async)"
                    [enabledFilters]="false"
                    [enabledDebug]="viewerService.developerTools$ | async"
                    [timelineBlocked]="viewerService.lockCollection$ | async"
                    [swipeStatus]="viewerService.enableSwipe$ | async"
            ></app-sbs-projects-timeline>

            <app-projects-discrete-selector
                    [aois]="(viewerService.projectStatus$ | async)?.enabledImageAOIs"
                    [selectedImage]="viewerService.image$ | async"
                    *ngIf="viewerService.is3DMode() && !(viewerService.isActivatedBaseMap$ | async)"
                    [class.d-none]="!(viewerService.projectStatus$ | async)?.enabledImageAOIs?.length"
            ></app-projects-discrete-selector>
        </div>
        <!-- collections + multilayer timelines -->
        <div class="top-toolbar-container" [ngClass]="{ 'dual-view-toolbar': dualView }"
             *ngIf="(viewerService.projectStatus$ | async)?.multiLayerEnabled">
            <app-dummy-collections-timeline
                    *ngIf="viewerService.showDummyTimeline() && !(viewerService.isActivatedBaseMap$ | async)"
                    [enabledFilters]="mapService.mapInitialized$ | async"
                    [enabledDebug]="viewerService.developerTools$ | async"
                    [timelineBlocked]="viewerService.lockCollection$ | async"
                    [swipeStatus]="viewerService.enableSwipe$ | async"
            ></app-dummy-collections-timeline>

            <app-collections-timeline
                    [aois]="(viewerService.projectStatus$ | async)?.enabledAOIs"
                    [centerAOI]="(viewerService.projectStatus$ | async)?.centerAOI"
                    [enabledFilters]="mapService.mapInitialized$ | async"
                    *ngIf="!enableSbsViewer && this.viewerService.show2DTimeline() && !(viewerService.isActivatedBaseMap$ | async)"
                    [enabledDebug]="viewerService.developerTools$ | async"
                    [timelineBlocked]="viewerService.lockCollection$ | async"
                    [enableContrast]="viewerService.enableContrast$ | async"
                    [swipeStatus]="viewerService.enableSwipe$ | async"
            ></app-collections-timeline>

            <app-sbs-projects-timeline
                    [aois]="(this.viewerService.projectStatus$ | async)?.enabledAOIs"
                    (layerChange)="this.sbsLeftLayer = $event"
                    [aoi]="this.sbsLeftLayer"
                    *ngIf="!dualView && enableSbsViewer && this.viewerService.show2DTimeline() && !(viewerService.isActivatedBaseMap$ | async)"
                    [enabledFilters]="false"
                    [enabledDebug]="viewerService.developerTools$ | async"
                    [timelineBlocked]="viewerService.lockCollection$ | async"
                    [swipeStatus]="viewerService.enableSwipe$ | async"
            ></app-sbs-projects-timeline>

            <app-sbs-projects-timeline
                    [aois]="(this.viewerService.projectStatus$ | async)?.enabledAOIs"
                    (layerChange)="this.sbsRightLayer = $event"
                    [aoi]="this.sbsRightLayer"
                    *ngIf="!dualView && enableSbsViewer && this.viewerService.show2DTimeline() && !(viewerService.isActivatedBaseMap$ | async)"
                    [enabledFilters]="false"
                    [enabledDebug]="viewerService.developerTools$ | async"
                    [timelineBlocked]="viewerService.lockCollection$ | async"
                    [swipeStatus]="viewerService.enableSwipe$ | async"
            ></app-sbs-projects-timeline>

            <app-collections-discrete-selector
                    [aois]="(viewerService.projectStatus$ | async)?.enabledImageAOIs"
                    [selectedImage]="viewerService.image$ | async"
                    *ngIf="viewerService.is3DMode() && !(viewerService.isActivatedBaseMap$ | async)"
                    [class.d-none]="!(viewerService.projectStatus$ | async)?.enabledImageAOIs?.length"
            ></app-collections-discrete-selector>
        </div>
        <div class="map-toolbar right-toolbar-container">
            <app-measurement-actions
                    *ngIf="enableMeasurementTools"
                    [mode]="viewerService.collectionMode"
                    [discreteEnabled]="mapService.discreteEnabled$ | async"
                    [dsmEvent]="viewerService.dsmStatus$ | async"
                    [measures]="viewerService.measuresSelected$ | async"
                    [deactivate]="viewerService.deactivateTools$ | async"
                    [measurementTools]="viewerService.measurementTools$ | async"
                    [exportFeature]="viewerService.exportFeature$ | async"
                    [debugMode]="viewerService.developerTools$ | async"
                    [image]="viewerService.image$ | async"
                    class="map-toolbar draw-measurement-action"></app-measurement-actions>
        </div>
        <div class="row align-items-start toolbar-toast-container">
            <app-vision-toast
                    [notification]="toastService.notifications$ | async"
                    [remove]="toastService.removeNotification$ | async"
                    [removeAll]="toastService.removeAllNotification$ | async"></app-vision-toast>
        </div>
        <div class="toolbar-viewer d-flex flex-column align-items-end ">

            <div class="m-2 d-flex flex-column align-items-end">


                <!-- Controller selector: solo uno visible a la vez -->
                @switch (activeController) {
                    @case (ControllerType.MAP) {
                        <!-- Map Controller (original) -->
                        <app-map-controller [mode]="viewerService.collectionMode"
                                            [orientation]="viewerService.orientationSelected"
                                            [imageAOIs]="(viewerService.projectStatus$ | async)?.enabledImageAOIs"
                                            [aois]="(viewerService.projectStatus$ | async)?.enabledAOIs"
                                            [centerAOI]="(viewerService.projectStatus$ | async)?.centerAOI"
                                            [zoom]="viewerService.zoomEnd$ | async"
                                            [initialized]="mapService.mapInitialized$ | async"
                                            [controllerBlocked]="viewerService.lockCollection$ | async"
                                            [isBaseMapActivated]="viewerService.isActivatedBaseMap$ | async"></app-map-controller>
                    }
                    @case (ControllerType.COMPACT_MAP) {
                        <!-- Compact Map Controller (nuevo) -->
                        <app-compact-map-controller
                                [mode]="viewerService.collectionMode"
                                [orientation]="viewerService.orientationSelected"
                                [imageAOIs]="(viewerService.projectStatus$ | async)?.enabledImageAOIs"
                                [aois]="(viewerService.projectStatus$ | async)?.enabledAOIs"
                                [centerAOI]="(viewerService.projectStatus$ | async)?.centerAOI"
                                [zoom]="viewerService.zoomEnd$ | async"
                                [initialized]="mapService.mapInitialized$ | async"
                                [isBaseMapActivated]="viewerService.isActivatedBaseMap$ | async"
                                [agents]="(flagService.getFlags$() | async)?.[FeatureFlags.AI_AGENTS] ? aiAgents : []">
                        </app-compact-map-controller>
                    }
                    @default {
                        <!-- Collection Controller (por defecto) -->
                        <div class="d-flex justify-content-end w-100">
                            <app-loading class="loading-div m-3 w-auto" [loadingId]="'tiles'"></app-loading>
                        </div>
                        <app-zoom-manager class="m-3 toolbar-item"></app-zoom-manager>
                        <app-collection-controller
                                [mode]="viewerService.collectionMode"
                                [orientation]="viewerService.orientationSelected"
                                [imageAOIs]="(viewerService.projectStatus$ | async)?.enabledImageAOIs"
                                [aois]="(viewerService.projectStatus$ | async)?.enabledAOIs"
                                [centerAOI]="(viewerService.projectStatus$ | async)?.centerAOI"
                                [zoom]="viewerService.zoomEnd$ | async"
                                [initialized]="mapService.mapInitialized$ | async"
                                [controllerBlocked]="viewerService.lockCollection$ | async"
                                [isBaseMapActivated]="viewerService.isActivatedBaseMap$ | async"
                                [agents]="(flagService.getFlags$() | async)?.[FeatureFlags.AI_AGENTS] ? aiAgents : []"
                                class="toolbar-item"></app-collection-controller>
                    }
                }

            </div>

            <div class="d-flex align-items-end">
                <app-scale-bar class="me-1 pe-auto"
                               [discreteEnabled]="mapService.discreteEnabled$ | async"
                               [unitSelected]="dualCommunicatorService.unitSelected$ | async"
                               [viewerConfiguration]="viewerConfigurationService.viewerConfiguration$ | async"></app-scale-bar>
                <app-status-bar

                        [target]="'custom-attribution-map' + mapService.getMapIndex()"
                        [centerAOI]="(viewerService.projectStatus$ | async)?.centerAOI"
                        [visibleDate]="viewerService.centerImageDate$ | async"
                        [mapCenterCoordinates]="viewerService.mapCenterCoordinates$ | async"
                        [discreteEnabled]="mapService.discreteEnabled$ | async"
                        [dsmStatus]="viewerService.dsmStatus$ | async"
                        [measurementToolStatus]="measurementCommunicatorService.measurementToolStatus$ | async"
                        [zoom]="viewerService.getZoom()"></app-status-bar>

            </div>
        </div>
        <app-phoenix-search-manager></app-phoenix-search-manager>
        <app-phoenix-viewer #viewer></app-phoenix-viewer>
        @if (reportService.progressBarMessage$ | async; as progressMessage) {
            <div class="download-bar">
                @if (!progressMessage.includes('Error')) {
                    <mat-card class="inverse-surface overlay">
                        <div class="d-flex">
                            <div class="d-flex align-items-center justify-content-between flex-grow-1 px-1">
                                <span>{{ reportService.getProgressBarMessage() }}</span>
                                @if (reportService.progressBarValue$ | async) {
                                    <span>
                    {{ reportService.getProgressBarValue().current + ' of ' + reportService.getProgressBarValue().total }}
                  </span>
                                }
                            </div>
                            <button matIconButton class="close-report-bar"
                                    (click)="reportService.setProgressBarMessage(null)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                        @if (reportService.progressBarValue$ | async) {
                            <mat-progress-bar
                                    id="determinate-progress-bar"
                                    class="download-progress-bar"
                                    mode="determinate"
                                    [value]="reportService.progressBarPercent"></mat-progress-bar>
                        } @else {
                            <mat-progress-bar mode="indeterminate" class="download-progress-bar"></mat-progress-bar>
                        }
                    </mat-card>
                } @else {
                    <mat-card>
                        <div class="d-flex">
                            <div class="d-flex align-items-center flex-grow-1">
                                <mat-icon class="report-error">error</mat-icon>
                                <span>{{ reportService.getProgressBarMessage() }}</span>
                            </div>
                            <button matIconButton class="close-report-bar"
                                    (click)="reportService.setProgressBarMessage(null)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </mat-card>
                }
            </div>
        }
    </div>
</div>
